export const styles = {
	accordion: {
		backgroundColor: 'transparent',
		py: 1,
	},
	accordionSummary: {
		px: 0,
		borderBottom: '1px solid #45657B',
	},
	expandIcon: {
		color: '#45657B',
		fontSize: '30px',
	},
	categoryTypography: {
		fontWeight: 'light',
		fontSize: '18px',
	},
}
